import { __ } from '@wordpress/i18n';
import {InspectorControls} from '@wordpress/block-editor';
import {VayuBlocksAdvancePanel} from '@vayu-blocks/advance-panel';
import PostSettings from './postSettings.js';
import StyleSettings from './StyleSettings.js';
import {VayuBlocksHeaderTab, usePanelSettings} from '@vayu-blocks';

const panelKeys = [
	'slide-size',
	'slide-image',
	'slide-effect',
	'slide-scrollbar',

	'slide-arrow',
	'slide-pagination',
	'slide-bar',
	'slide-frame',
];

const initialPanels = {
    slide: 'slide-size',
	style: '',
    advanced: '',
};

const panelOptions = [
	{ label: __( 'Slider', 'vayu-blocks' ), value: 'slide', icon: 'slide'},
	{ label: __( 'Style', 'vayu-blocks' ), value: 'style', icon: 'diamond'},
	{ label: __( 'Advanced', 'vayu-blocks' ), value: 'advanced', icon: 'colorpalette'}
];

const PanelSettings = ({attributes,setAttributes,isSelected,clientId}) => {

	const { tab, setTab, openPanels, onTogglePanel } = usePanelSettings({ clientId, panelKeys, initialPanels, defaultTab: 'slide' });

	const tabComponents = {
		slide: <PostSettings clientId={clientId} attributes={attributes} setAttributes={setAttributes} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
		style: <StyleSettings attributes={attributes} setAttributes={setAttributes} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
		advanced: <VayuBlocksAdvancePanel attributes={attributes} setAttributes={setAttributes} clientId={clientId} exclude={['Cursor', 'cursorFollower', 'width', 'flex']} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
	};

    return (
		<>
			{isSelected && (
				<InspectorControls>
					<div className='th-block-ins th-button-panel'>

						<VayuBlocksHeaderTab 
							value={ tab }
							options={panelOptions}
							onChange={ setTab }
						/>

						{tabComponents[tab]}

					</div>
				</InspectorControls>  
			)}

    	</>
	);
}

export default PanelSettings;